<template>
  <div class="image-box">
    <img
      v-if="!hasLoadError"
      v-bind="$attrs"
      @error="handleError"
    >
    <img
      v-else
      :src="defaultImg"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import defaultImg from '../../assets/imgs/defaultImg.png'

export default {
  name: 'ImageBox',
  props: {
    defaultImg: {
      type: String,
      default: defaultImg
    }
  },
  computed: {
  },
  watch: {
    '$attrs.src'(val) {
      this.hasLoadError = false
    }
  },
  data() {
    return {
      hasLoadError: false,
    }
  },
  methods: {
    handleError() {
      this.hasLoadError = true
    }
  }
};
</script>

<style scoped lang="scss">
.image-box {
  width: 100%;
  height: 100%;
  img {
    // vertical-align: middle;
    display: block;
    // width: 100%;
    // height: auto;
  }
}
</style>
